// App.js - Composant principal
import React, { useState, useEffect } from 'react';

import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import EvenementDetail from '../Dashboard/EvenementDetail';


function CustomEventDetailPages({tel}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
 

  // Détection de la taille d'écran pour le mode mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="app">
      <Sidebar
        isOpen={sidebarOpen} 
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <div className="main-content">
        <Navbar
          tel={tel}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <EvenementDetail tel={tel}  />
         
      
      </div>
    </div>
  );
}

export default CustomEventDetailPages;